module.exports = __webpack_public_path__ + "static/media/unboxing_summer_2.6eb8de69.jpg";